module.exports = __webpack_public_path__ + "img/bluedownload.f304c86d.svg";